import React, { FC, ReactNode, useState } from 'react';

import {
  Box,
  Button,
  Checkbox,
  HStack,
  Header,
  IconButton,
  VStack,
} from '@rbilabs/universal-components';
import { Clipboard, Text } from 'react-native';

import theme from '../theme';

export interface IEnvItem {
  envKey: string;
  value?: string | null;
}

export const EnvTitle = Box.withConfig({
  _text: {
    color: theme.envTitleColor,
  },
  flex: 1,
});

export const EnvDescription = ({ children }: { children: ReactNode }) => {
  let value = children;

  try {
    if (typeof children === 'string') {
      value = JSON.parse(children);
    }
  } catch (_) {
    value = children;
  }

  return (
    <Box
      _text={{
        fontSize: 'sm',
        fontWeight: 'normal',
        textAlign: 'left',
      }}
      background="white"
      borderRadius="md"
      mt="$2"
      p="$2"
      overflow={'auto'}
    >
      <Text
        style={{
          fontSize: 12,
          fontWeight: 'normal',
          textAlign: 'left',
          fontFamily: 'monospace',
          lineHeight: 14,
        }}
      >
        {JSON.stringify(value, null, 2)}
      </Text>
    </Box>
  );
};

export const EnvItem = ({ envKey, value }: IEnvItem) => {
  if (typeof value === 'boolean') {
    value = value ? 'true' : 'false';
  }
  return (
    <VStack pb={'$2'} width="full">
      <HStack alignItems="center">
        <EnvTitle>{envKey}</EnvTitle>
        <IconButton
          size="sm"
          iconName="info"
          onPress={() => {
            if (value) {
              Clipboard.setString(value);
              alert(`Copied text "${value}"`);
            }
          }}
        />
      </HStack>
      <EnvDescription>{value ?? 'unknown'}</EnvDescription>
    </VStack>
  );
};

interface IEnvItemBoolean {
  envKey: string;
  value: boolean;
}

export const EnvItemBoolean = ({ envKey, value }: IEnvItemBoolean) => (
  <Checkbox marginY="$4" name={envKey} value={envKey} isChecked={!!value}>
    {envKey}
  </Checkbox>
);

export const HiddenEnvItem = ({ envKey, value }: IEnvItem) => {
  const [visible, setVisible] = useState(false);
  if (typeof value === 'boolean') {
    value = value ? 'true' : 'false';
  }

  return (
    <VStack pb={'$1'} width="full">
      <HStack justifyContent="space-between" alignItems="center">
        <EnvTitle>{envKey}</EnvTitle>
        <Button onPress={() => setVisible(v => !v)} size={'md'} variant="ghost" mb="$1">
          {visible ? 'Hide Value' : 'Show Value'}
        </Button>
      </HStack>
      {visible ? <EnvDescription>{value ?? 'unknown'}</EnvDescription> : null}
    </VStack>
  );
};

export const ServiceModeItem: FC<React.PropsWithChildren<any>> = ({ envKey, value }) => (
  <Box>
    <Header variant="headerFour" mb="$1">
      {envKey}
    </Header>
    <Box mb="$4" background="white" px="$2" py="$2" borderRadius="md">
      {Object.keys(value).map(statusKey => (
        <Box key={statusKey} flexDir={'row'}>
          {statusKey}
          {': '}
          {Boolean(value[statusKey]).toString()}
        </Box>
      ))}
    </Box>
  </Box>
);
